
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue'

@Component({
  name: 'DeviceHelpSection'
})
export default class DeviceHelpSection extends Vue {
  @Prop({ default: false })
  private hasNoTrips: boolean;

  @Prop({ default: false })
  private teaserWidget: boolean;
}
